// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './Routes';
import ThemeSwitcher from './components/ThemeSwitcher';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';


function App() {
  return (
    <div className="App" >
      <HelmetProvider>
        <Helmet>
          <body className="antialiased text-slate-500 dark:text-slate-400 bg-white dark:bg-slate-900 " />        
        </Helmet>  
        <Router>  
          <Routes />
        </Router>
        <ThemeSwitcher />
        <ToastContainer />       
      </HelmetProvider>
    </div>
  );
}

export default App;
